import Row from './Row';
import styled from '@emotion/styled';

const Subtitle = styled(Row)({
  marginTop: '1.5rem',
});

export default Subtitle;
